export default __webpack_public_path__ + "static/media/mysql_monitor.6253fb10.md";